/**
 * swatch-overflow.js
 *
 * Limits color swatch rows to a single line and appends a "+N" toggle
 * button for overflow swatches, matching the Figma design intent.
 *
 * Works on both desktop and mobile after the mobile width CSS fix
 * (variant-picker__option:has(--color/--swatch) → width: auto).
 */
(function () {
  var ITEM_SIZE = 30; // px — matches .variant-picker__option-button--color width
  var ITEM_GAP  = 10; // px — matches .variant-picker__color .variant-picker__option-values gap

  function initSwatchOverflow() {
    var containers = document.querySelectorAll(
      '.variant-picker__color .variant-picker__option-values'
    );

    containers.forEach(function (container) {
      // Guard: skip if already initialised
      if (container.dataset.overflowInit) return;
      container.dataset.overflowInit = '1';

      var options = Array.from(
        container.querySelectorAll('.variant-picker__option')
      );
      if (options.length === 0) return;

      // ------------------------------------------------------------------
      // Measure how many items fit in one row.
      // Reserve space for the "+N" button on every row except when all
      // swatches already fit.
      // ------------------------------------------------------------------
      var containerWidth = container.getBoundingClientRect().width;
      var plusBtnSlot = ITEM_SIZE + ITEM_GAP; // room needed for the "+N" pill

      var usedWidth    = 0;
      var visibleCount = 0;

      for (var i = 0; i < options.length; i++) {
        var slotWidth = ITEM_SIZE + (i > 0 ? ITEM_GAP : 0);
        var isLast    = i === options.length - 1;
        // On the last item we don't need a "+N" slot; otherwise we do
        var needed = usedWidth + slotWidth + (isLast ? 0 : plusBtnSlot);

        if (needed <= containerWidth) {
          usedWidth += slotWidth;
          visibleCount++;
        } else {
          break;
        }
      }

      // Nothing to collapse
      if (visibleCount >= options.length) return;

      var hiddenItems  = options.slice(visibleCount);
      var hiddenCount  = hiddenItems.length;
      var isExpanded   = false;

      // Hide overflow items
      hiddenItems.forEach(function (item) {
        item.style.display = 'none';
      });

      // Build "+N" button
      var btn       = document.createElement('button');
      btn.type      = 'button';
      btn.className = 'swatch-overflow-btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Show ' + hiddenCount + ' more colors');
      btn.textContent = '+' + hiddenCount;
      container.appendChild(btn);

      btn.addEventListener('click', function () {
        isExpanded = !isExpanded;

        hiddenItems.forEach(function (item) {
          item.style.display = isExpanded ? '' : 'none';
        });

        btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        btn.setAttribute(
          'aria-label',
          isExpanded ? 'Show fewer colors' : 'Show ' + hiddenCount + ' more colors'
        );
        btn.textContent = isExpanded ? '\u2212' : '+' + hiddenCount; // − or +N

        // Keep the button always last in the row
        container.appendChild(btn);
      });
    });
  }

  // Run once on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchOverflow);
  } else {
    initSwatchOverflow();
  }
})();
